import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import {
  UpsertClaimMutation,
  UpsertClaimMutationVariables,
} from '../gql/graphql';
import { GET_CLAIMS } from './claims.query';

interface UpsertClaimMutationOptions
  extends MutationHookOptions<
    UpsertClaimMutation,
    UpsertClaimMutationVariables
  > {
  shouldRefetch?: boolean;
}

export function useUpsertClaimMutation(
  options: UpsertClaimMutationOptions = {}
) {
  const { shouldRefetch = true, ...mutationOptions } = options;
  const [upsertClaim, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation upsertClaim($claimInput: ClaimInput!) {
        upsertClaim(details: $claimInput) {
          uuid
          tenant
          description
        }
      }
    `),
    {
      ...mutationOptions,
      ...(shouldRefetch && {
        refetchQueries: [GET_CLAIMS],
        awaitRefetchQueries: true,
      }),
    }
  );

  return {
    upsertClaim,
    loading,
    error,
    reset,
    data,
  };
}
